import site from '../../extends/site';
const defaultSite = {
    title: '云枢',
    logo: require('@/assets/images/yslogo.png'),
};
const mix = Object.assign({}, defaultSite, site);
export default mix;
